import React, { useRef, useState } from "react";
import "./Founder_Modal.css";
import SuccesfullModal from "../SuccesfullModal/SuccesfullModal";
import { Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

function Founder_Modal({modalImgSrc, ModalNameText, modalSubHeadingText,modalHeadingText, ModalDescriptionText, ...props}) {
  const [modalShow, setModalShow] = React.useState(false);

  return (
    <>
      <section className="Apply_Modal_modal Founder_Modal">
        <Modal
          {...props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className=" Founder_Modal"
        >
          <Modal.Body>
            <div className="close-btn">
              <FontAwesomeIcon
                className="close-icon"
                icon={faCircleXmark}
                onClick={props.onHide}
              />
            </div>
            <div className="row justify-content-center">
              <div className="col-xl-5  col-md-6  col-lg-6 col-8 ">
                <div className="founder-img-holder">
                  <div className="img-holder">
                    <img
                      className="founder-img"
                      src={
                        process.env.PUBLIC_URL +
                        modalImgSrc
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="col-xl-7  col-md-12 col-lg-6 col-12">
                <div className="Founder-content">
                  <div className="founder-name-holder">
                    <h2 className="">{ModalNameText}</h2>
                  </div>

                  <div className="sub-heading-holder">
                    <h4>
                      {modalSubHeadingText}{" "}
                      <span>{modalHeadingText}</span>
                    </h4>
                  </div>

                  <div className="founder-info-holder">
                    <p>
                    {ModalDescriptionText}
                    </p>

                   
                  </div>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>

      <SuccesfullModal
        message={"Form submitted successfully !"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Founder_Modal;
